import { render, staticRenderFns } from "./dataSearch.vue?vue&type=template&id=54001c24&scoped=true"
import script from "./dataSearch.vue?vue&type=script&lang=js"
export * from "./dataSearch.vue?vue&type=script&lang=js"
import style0 from "./dataSearch.vue?vue&type=style&index=0&id=54001c24&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54001c24",
  null
  
)

export default component.exports